import React from 'react';

import classNames from 'classnames';

import {Icon} from '../icon/icon';

export interface IIndicatorProps {
    color: TIndicatorColor;
    number: number;
    className?: string;
    isNumberNotVisible?: boolean
}

export type TIndicatorColor = 'red' | 'green' | 'grey';

const Indicator = (props: IIndicatorProps): JSX.Element => {
    const className: string = classNames(
        'indicator',
        {
            [`indicator--color-${props.color}`]: !!props.color,
        },
        props.className,
    );

    return (
        <div className={className}>
            <Icon className="indicator__icon" name={props.number > 0 ? 'arrow-up' : 'arrow-down'} />
            {props.isNumberNotVisible === true ? undefined : <span className="indicator__text text-small">
                {props.number}
            </span>}
        </div>
    );
};

export default Indicator;
